export const load = () => ({
	title: 'Step-by-step Guide To Measuring With Tape',
	h1: 'How To Measure Using Tape',
	description: 'Learn how to measure your windows with your own tape measure.',
	showTitle: false,

	hideHeaderButton: false,
	headerPosition: 'relative',
});
